import { render, staticRenderFns } from "./oceanEdit.vue?vue&type=template&id=72dce61d"
import script from "./oceanEdit.vue?vue&type=script&lang=js"
export * from "./oceanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports